export const BRAND = {
  name: '',
  bio: $localize`:@@homePage.oth.description:SR Group Description Placeholder`,
  establishDate: '2020-01-01',
  heroImage: {
    src: '',
    description: 'SR Group Hero Image'
  },
  logo: {
    main: './assets/logo/brand.svg',
    error: './assets/logo/brand.svg',
    maintenance: '',
    fixed: '',
  },
  badges: [
    '',
    ''
  ],
  wallpapers: [
    'https://raw.githubusercontent.com/open-template-hub/open-template-hub.github.io/master/assets/min/wallpaper/logo-text-v-color.min.png',
    'https://raw.githubusercontent.com/open-template-hub/open-template-hub.github.io/master/assets/min/wallpaper/logo-text-v-light.min.png',
    'https://raw.githubusercontent.com/open-template-hub/open-template-hub.github.io/master/assets/min/wallpaper/logo-text-v-dark.min.png',
    'https://raw.githubusercontent.com/open-template-hub/open-template-hub.github.io/master/assets/min/wallpaper/oth-packages-color.min.png',
    'https://raw.githubusercontent.com/open-template-hub/open-template-hub.github.io/master/assets/min/wallpaper/oth-packages-light.min.png',
    'https://raw.githubusercontent.com/open-template-hub/open-template-hub.github.io/master/assets/min/wallpaper/oth-packages-dark.min.png',
    'https://raw.githubusercontent.com/open-template-hub/open-template-hub.github.io/master/assets/min/wallpaper/oth-packages-2-color.min.png',
  ],
  mobileWallpapers: []
};
